export const convertDecimal = (value: string) => {
  return Number(value);
};
